<div class="ts1-report-preview">
	<div class="ts1-report-preview__header">
		<h2>{{ summaryReportTitle }}</h2>
		@if (reportSummary; as rs) {
			@if (rs.logo) {
				<img [src]="rs.logo" alt="AOC" class="ts1-report-preview__logo" />
			}
		}
	</div>

	@if (candidateDetails; as details) {
		<div class="ts1-report-preview__meta">
			<div class="ts1-report-preview__field">
				<div class="ts1-report-preview__label">Training Date</div>
				<div class="ts1-report-preview__value">{{ details.trainingDate }}</div>
			</div>
			<div class="ts1-report-preview__field">
				<div class="ts1-report-preview__label">Session Details</div>
				<div class="ts1-report-preview__value">
					@for (cfg of details.sessionConfigurations; track cfg.description; let last = $last) {
						<span>{{ cfg.description }}</span>
						@if (cfg.selectionRemarks) {
							<span>: {{ cfg.selectionRemarks }}</span>
						}
						@if (!last) {
							<span>, </span>
						}
					}
				</div>
			</div>
		</div>

		<div class="ts1-report-preview__section-title">Candidate Details</div>
		<div class="ts1-report-preview__grid">
			<div class="ts1-report-preview__field">
				<div class="ts1-report-preview__label">Name</div>
				<div class="ts1-report-preview__value">{{ details.name }}</div>
			</div>
			<div class="ts1-report-preview__field">
				<div class="ts1-report-preview__label">Rank</div>
				<div class="ts1-report-preview__value">{{ details.rank }}</div>
			</div>
			<div class="ts1-report-preview__field">
				<div class="ts1-report-preview__label">Staff No.</div>
				<div class="ts1-report-preview__value">{{ details.staffNumber }}</div>
			</div>
			<div class="ts1-report-preview__field">
				<div class="ts1-report-preview__label">Pilot Profile</div>
				<div class="ts1-report-preview__value">{{ details.pilotProfile }}</div>
			</div>
			<div class="ts1-report-preview__field">
				<div class="ts1-report-preview__label">License Number, ATPL/CPL</div>
				<div class="ts1-report-preview__value">{{ details.licenseNo }}</div>
			</div>
			<div class="ts1-report-preview__field">
				<div class="ts1-report-preview__label">License Type</div>
				<div class="ts1-report-preview__value">{{ details.licenseType }}</div>
			</div>
		</div>
	}

	<div class="ts1-report-preview__section-title">Final Rating</div>
	<div class="ts1-report-preview__grid">
		<div class="ts1-report-preview__field">
			<div class="ts1-report-preview__label">Rating A</div>
			<div class="ts1-report-preview__value">{{ ratings.ratingA ?? "—" }}</div>
		</div>
		<div class="ts1-report-preview__field">
			<div class="ts1-report-preview__label">Rating B</div>
			<div class="ts1-report-preview__value">{{ ratings.ratingB ?? "—" }}</div>
		</div>
		<div class="ts1-report-preview__field">
			<div class="ts1-report-preview__label">Rating C</div>
			<div class="ts1-report-preview__value">{{ ratings.ratingC ?? "—" }}</div>
		</div>
		<div class="ts1-report-preview__field">
			<div class="ts1-report-preview__label">Final Rating</div>
			<div class="ts1-report-preview__value">{{ ratings.finalRating ?? "—" }}</div>
		</div>
	</div>

	@if (maneuverRows.length) {
		<div class="ts1-report-preview__section-title">Maneuver Ratings</div>
		<div class="ts1-report-preview__maneuver-table">
			<div class="ts1-report-preview__maneuver-header">
				<span>Phase</span>
				<span>PF</span>
				<span>PM</span>
			</div>
			@for (row of maneuverRows; track row.maneuverCode) {
				<div class="ts1-report-preview__maneuver-row">
					<span>{{ row.label }}</span>
					<span>{{ row.pf ?? "—" }}</span>
					<span>{{ row.pm ?? "—" }}</span>
				</div>
			}
		</div>
	}

	@if (recommendation) {
		<div class="ts1-report-preview__section-title">Recommendation</div>
		<div class="ts1-report-preview__grid">
			<div class="ts1-report-preview__field">
				<div class="ts1-report-preview__label">Session Type</div>
				<div class="ts1-report-preview__value">
					{{ recommendationSessionLabel(recommendation) }}
				</div>
			</div>
			@if (isRecommendationTraining(recommendation)) {
				<div class="ts1-report-preview__field">
					<div class="ts1-report-preview__label">Session Completed</div>
					<div class="ts1-report-preview__value">{{ formatRecommendationYesNo(recommendation.is_complete) }}</div>
				</div>
			} @else {
				<div class="ts1-report-preview__field">
					<div class="ts1-report-preview__label">Objectives Met</div>
					<div class="ts1-report-preview__value">{{ formatRecommendationObjective(recommendation) }}</div>
				</div>
				<div class="ts1-report-preview__field">
					<div class="ts1-report-preview__label">Cleared for Check</div>
					<div class="ts1-report-preview__value">{{ formatRecommendationClearance(recommendation) }}</div>
				</div>
			}
		</div>
	}
</div>
